import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '日本电影', path: '/category/japanese-movie' },
    { name: '韩国电影', path: '/category/korean-movie' },
    { name: '影片分类', path: '#', isDropdown: true, children: categories.filter(c => c.slug !== 'japanese-movie' && c.slug !== 'korean-movie') },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
        isScrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-700))]'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg group-hover:bg-primary-400 transition-colors duration-300">
              <i className="ri-movie-2-fill text-lg text-background-950"></i>
            </div>
            <span className="text-lg font-bold text-foreground-50 font-heading tracking-wide">
              日韩影视网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) =>
              link.isDropdown ? (
                <div key="dropdown" className="relative group">
                  <button className="flex items-center gap-1 px-3 py-2 text-sm text-foreground-300 hover:text-foreground-50 rounded-lg hover:bg-background-800/60 transition-all duration-200 whitespace-nowrap cursor-pointer">
                    {link.name}
                    <i className="ri-arrow-down-s-line text-xs opacity-60"></i>
                  </button>
                  <div className="absolute top-full left-0 mt-1 w-40 bg-background-900 border border-background-700 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-1 z-50">
                    {link.children?.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="block px-4 py-2 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-800 transition-colors duration-150 whitespace-nowrap"
                      >
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 text-sm rounded-lg transition-all duration-200 whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-primary-400 bg-primary-500/10'
                      : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-800/60'
                  }`}
                >
                  {link.name}
                </Link>
              ),
            )}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-800/60 transition-all duration-200 cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-200 hover:bg-background-800/60 transition-all duration-200 cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-lg ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-t border-background-700">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) =>
              link.isDropdown ? (
                <div key="mobile-dropdown" className="flex flex-col">
                  <span className="px-3 py-2 text-sm text-foreground-400 font-medium">{link.name}</span>
                  {link.children?.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-6 py-2 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-800/60 rounded-lg transition-colors duration-150"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2.5 text-sm rounded-lg transition-all duration-200 ${
                    location.pathname === link.path
                      ? 'text-primary-400 bg-primary-500/10'
                      : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-800/60'
                  }`}
                >
                  {link.name}
                </Link>
              ),
            )}
          </div>
        </div>
      )}
    </header>
  );
}